import { useCallback, useMemo, useState } from "react";
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as services from "../services/employeeApi";
import { setEmployeeYearAccumulate } from '../slices/salarySlice';
import { setIsLoading } from '../slices/employeeSlice';
import { useParams } from "react-router-dom";
import ModalSalaryAccumulate from "components/elements/Modal/ModalSalaryAccumulate";
import dayjs from "dayjs";
import { message } from "antd";
import { useTranslation } from "react-i18next";

function useEmployeeSalaryAccumulate() {
  const { t } = useTranslation();
  const [isModalOpen, setModalOpen] = useState(false);
  const dispatch = useDispatch()
  const { currentCompany } = useSelector((state) => state.company)
  const { currentEmployee, isLoading, } = useSelector((state) => state.employee)
  const { employeeYearAccumulate } = useSelector((state) => state.salary)
  const [txnAccumulateId, setTxnAccumulateId] = useState()
  const [accumulateType, setAccumulateType] = useState();
  const [selectedYear, setSelectedYear] = useState(dayjs().year());

  let params = useParams();


  const getEmployeeYearAccumulate = useCallback(async (year) => {
    try {
      dispatch(setIsLoading(true))
      const response = await services.getEmployeeYearAccumulateByEmpId({
        companyId: currentCompany,
        employeeId: params?.id,
        actionId: currentEmployee,
        year: year || selectedYear
      })
      dispatch(setEmployeeYearAccumulate(response?.data?.content?.accumulatedList))
      setTxnAccumulateId(response?.data?.content?.id)
    } catch (error) {
      // dispatch(setIsLoading(false))
    } finally {
      dispatch(setIsLoading(false))
    }
  }, [currentCompany, currentEmployee, isLoading, params, selectedYear])

  const editEmployeeYearAccumulate = useCallback(async (values) => {
    try {
      dispatch(setIsLoading(true))
      const response = await services.editTxnEmployeeYearAccumulate({
        companyId: currentCompany,
        employeeId: params?.id,
        actionId: currentEmployee,
        type: values?.type,
        amount: values?.amount,
        txnEmployeeYearAccumulateId: txnAccumulateId
      })
      message.success(t("common.success"))
      getEmployeeYearAccumulate()
    } catch (error) {
      message.error(t("common.error"))
    } finally {
      dispatch(setIsLoading(false))
    }
  }, [currentCompany, currentEmployee, isLoading, getEmployeeYearAccumulate, params, txnAccumulateId])

  const onSubmit = useCallback(async (values) => {
    await editEmployeeYearAccumulate(values)
    setModalOpen(false);
    setAccumulateType()
  }, [editEmployeeYearAccumulate])

  const onEdit = (record) => {
    setModalOpen(true);
    setAccumulateType(record)
  }

  const onCancel = useCallback(() => {
    setModalOpen(false);
    setAccumulateType()
    setTxnAccumulateId(null)
  }, [])

  const onYearChange = useCallback((date) => {
    const year = date ? date.year() : dayjs().year();
    setSelectedYear(year);
    getEmployeeYearAccumulate(year);
  }, [getEmployeeYearAccumulate])

  const getModal = useMemo(() => {
    return <ModalSalaryAccumulate
      isModalOpen={isModalOpen}
      setIsModalOpen={setModalOpen}
      onCancel={onCancel}
      initialValues={accumulateType}
      onSubmit={onSubmit} />
  }, [isModalOpen, accumulateType])

  useEffect(() => {
    if (currentCompany && params) {
      getEmployeeYearAccumulate(selectedYear)
    }
  }, [currentCompany])


  return {
    onEdit,
    onCancel,
    isModalOpen,
    onSubmit,
    editEmployeeYearAccumulate,
    employeeYearAccumulate,
    getModal,
    selectedYear,
    onYearChange
  }
}


export default useEmployeeSalaryAccumulate;
